
export class Rol {
    uid: string;
    name: string;
    cn: string;
    dn: string;
    type: string;
}